/**
 * Normalize unknown auth errors into a safe, user-displayable string.
 * Never returns "{}", "[object Object]", or blank whitespace.
 */

export function getAuthErrorMessage(error: unknown): string {
  if (error == null) return '';

  if (typeof error === 'string') {
    const trimmed = error.trim();
    if (!trimmed || trimmed === '{}' || trimmed === '[object Object]') return '';
    return trimmed;
  }

  if (typeof error === 'object') {
    const maybeMessage = (error as { message?: unknown }).message;
    if (typeof maybeMessage === 'string') {
      const trimmed = maybeMessage.trim();
      if (trimmed && trimmed !== '{}' && trimmed !== '[object Object]') {
        return trimmed;
      }
    }
  }

  return '';
}

/** Safe diagnostics for unexpected errors — never logs emails, passwords, tokens, or full auth payloads. */
export function logUnexpectedAuthError(scope: string, error: unknown): void {
  if (process.env.NODE_ENV === 'production') return;
  const name =
    error && typeof error === 'object' && 'name' in error
      ? String((error as { name?: unknown }).name ?? 'Error')
      : typeof error;
  const code =
    error && typeof error === 'object' && 'status' in error
      ? String((error as { status?: unknown }).status ?? '')
      : '';
  const message = getAuthErrorMessage(error);
  console.warn(
    `[${scope}] unexpected auth error`,
    { name, code: code || undefined, message: message || undefined }
  );
}
